import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  FilePathAutocompleteQuery,
  FilePathAutocompleteResponse,
} from '@hud/portal-dtos/webapp-autocomplete.dto';
import { PORTAL_BASE } from '../consts';

export const FUNCTIONS_ID = 'functions';

export default function useFilePathsAutocompleteQuery(
  query: FilePathAutocompleteQuery,
) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [FUNCTIONS_ID, query],
    queryFn: async () => {
      const response = await client.get<FilePathAutocompleteResponse>(
        `${PORTAL_BASE}/autocomplete/file-paths`,
        {
          params: query,
        },
      );
      return FilePathAutocompleteResponse.parse(response.data);
    },
    placeholderData: keepPreviousData,
    enabled: isReady,
  });
}
